import client from './client'

export default {
  contactHome (form) {
    var bodyFormData = {}
    bodyFormData['Name'] = form.name
    bodyFormData['Email'] = form.email
    bodyFormData['Organisation'] = form.company
    bodyFormData['PhoneNumber'] = form.phone
    bodyFormData['InterestedIn'] = form.question
    bodyFormData['Reason'] = form.reason
    return client.withoutAuth().post('womapi/api/account/contact', {}, bodyFormData)
  },
  contactDashboard (form) {
    var bodyFormData = {}
    bodyFormData['Name'] = form.name
    bodyFormData['Email'] = form.email
    bodyFormData['Organisation'] = form.company
    bodyFormData['PhoneNumber'] = form.phone
    bodyFormData['InterestedIn'] = form.question
    bodyFormData['Reason'] = form.reason
    return client.withAuth().post('womapi/api/account/contact', {}, bodyFormData)
  }
}
